import React from 'react';
import ComponentHelper from '../../../supers/ComponentHelper';
import ListPanel from '../../../components/list-panel/ListPanel';

class EntityDefPanel extends ComponentHelper {
	constructor(props) {
		super(props);
		this.data = {
			definitions: [],
			defMap: {},
			searchText: ''
		};
		this.autoBind(['onCreate', 'buildDefList', 'onSearchChange']);
	}

	onSearchChange(evt) {
		this.setData('searchText', evt.target.value);
	}

	onCreate() {
		alert('TODO');
	}

	componentDidMount() {
		// connect.getAppDefs().then(res => {
		// 	this.observe(() => {
		// 		this.data.definitions = res.data;
		// 		this.data.defMap = CS.mapByParam('_id', res.data);
		// 		this.data.loading = false;
		// 	});
		// });
	}

	buildDefList() {
		let defs = this.data.definitions;
		if (defs.length <= 0) {
			return <div className="empty-list">This platform has no definitions yet.</div>;
		}
		let items = [];
		for (let i = 0; i < defs.length; i++) {
			let def = defs[i];
			items.push(
				<div className="list-item hbox vcenter" key={'list-item-' + def._id}>
					{def.name}
				</div>
			);
		}
		return items;
	}

	render() {
		return (
			<div className="ent-definitions-panel-view animated fadeIn">
				<div className="ent-definitions-panel-header hbox vcenter hright">
					<div className="search-ctn hbox vcenter">
						<i className="mdi mdi-magnify" />
						<input className="search-input" value={this.data.searchText} onChange={this.onSearchChange} placeholder="Search Definitions..." />
					</div>
				</div>
				<ListPanel
					name="Entity Definitions List"
					className="ent-def-list-view"
					labels={['name', 'created', 'version', 'actions']}
					onCreate={this.onCreate}
					listItems={this.buildDefList()}
				/>
			</div>
		);
	}
}

export default EntityDefPanel;



// WEBPACK FOOTER //
// ./src/views/application-builder/entity-def-panel/EntityDefPanel.js